import { Component, Inject, Injector, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BehaviorSubject } from 'rxjs';
import { Info } from '../../../../public-api';
import { AbstractComponent } from '../../../commons/abstract.component';

export interface InfoComponentData {
  infos: Array<Info>;
}

export const currentInfoKey: string = 'currentInfoKey_';

@Component({
    selector: 'info-component',
    // templateUrl: './info.component.html',
    templateUrl: './info.v2.component.html',
    styleUrls: ['./info.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InfoComponent extends AbstractComponent {

  public infos: Array<Info> = Array<Info>();
  public currentInfo: Info | null = null;
  public currentIndex: number = 0;

  loadingSpinnerSubject = new BehaviorSubject<boolean>(true);
  loadingSpinner$ = this.loadingSpinnerSubject.asObservable();

  constructor(
    injector: Injector,
    @Inject(MAT_DIALOG_DATA) public data: InfoComponentData,
    private _matDialogRef: MatDialogRef<InfoComponent>,
  ) {
    super(injector);
  }

  public ngOnInit(): void {
    this.infos = this.data.infos;
    this.currentInfo = this.infos[this.currentIndex];
  }

  public get hasNext(): boolean {
    return this.currentIndex < this.infos.length - 1;
  }

  public get hasPrevious(): boolean {
    return this.currentIndex > 0;
  }

  public onNextInfo(): void {
    localStorage.setItem(currentInfoKey + this.currentInfo._id, 'true');
    if (this.currentIndex < this.infos.length - 1) {
      this.currentIndex++;
      this.currentInfo = this.infos[this.currentIndex];
    }
  }

  public onPreviousInfo(): void {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.currentInfo = this.infos[this.currentIndex];
    }
  }

  public close(): void {
    localStorage.setItem(currentInfoKey + this.currentInfo._id, 'true');
    this._matDialogRef.close();
  }

  public onImageClick(): void {
    if (this.currentInfo && this.currentInfo.contentUrl) {
      window.open(this.currentInfo.contentUrl, '_blank');
    }
  }

}